var map = {
	"./en/badges.png": 6626,
	"./en/crash.png": 2981,
	"./en/duel-equipment.png": 2453,
	"./en/duel.png": 6702,
	"./en/greetings-tests.png": 7408,
	"./en/interactions.png": 6089,
	"./en/jackpot-modal.png": 844,
	"./en/jackpot.png": 9243,
	"./en/job-ending.png": 4987,
	"./en/job-menu.png": 6899,
	"./en/job-select.png": 6668,
	"./en/leaders.png": 7855,
	"./en/minefield.png": 6548,
	"./en/rsp-accept.png": 9795,
	"./en/rsp-player.png": 2024,
	"./en/rsp-winner.png": 8474,
	"./en/rsp.png": 4587,
	"./en/shop.png": 7253,
	"./en/slashes.png": 9190,
	"./en/template.png": 8110,
	"./ru/badges.png": 3112,
	"./ru/crash.png": 4065,
	"./ru/duel-equipment.png": 7628,
	"./ru/duel.png": 4628,
	"./ru/greetings-tests.png": 9546,
	"./ru/interactions.png": 9378,
	"./ru/jackpot-modal.png": 198,
	"./ru/jackpot.png": 9999,
	"./ru/job-ending.png": 8105,
	"./ru/job-menu.png": 6527,
	"./ru/job-select.png": 6032,
	"./ru/leaders.png": 2106,
	"./ru/minefield.png": 1673,
	"./ru/rsp-accept.png": 53,
	"./ru/rsp-player.png": 368,
	"./ru/rsp-winner.png": 7260,
	"./ru/rsp.png": 7411,
	"./ru/shop.png": 9930,
	"./ru/slashes.png": 5284,
	"./ru/template.png": 3147
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5113;